/**
 * Copy Button Web Component
 * 可复制文本的按钮组件
 * 
 * Usage:
 * <copy-button data-copy-text="要复制的文本">复制</copy-button>
 * 
 * Attributes:
 * - data-copy-text: 要复制的文本内容（必需）
 * - data-copy-success: 复制成功后显示的文本（默认：'Copied!'）
 * - data-copy-duration: 成功文本显示的时间（默认：2000毫秒）
 */

if (!customElements.get('copy-button')) {
  customElements.define(
    'copy-button',
    class CopyButton extends HTMLElement {
      constructor() {
        super();
        this.originalText = '';
        this.copyText = '';
        this.successText = 'Copied!';
        this.duration = 2000;
      }

      connectedCallback() {
        this.init();
        this.addEventListeners();
      }

      init() {
        // 保存原始文本
        this.originalText = this.textContent.trim();
        
        // 获取属性值
        this.copyText = this.getAttribute('data-copy-text') || '';
        this.successText = this.getAttribute('data-copy-success') || this.successText;
        this.duration = parseInt(this.getAttribute('data-copy-duration')) || this.duration;
        
        // 设置默认样式（如果没有外部样式）
        if (!this.hasAttribute('class')) {
          this.classList.add('btn', 'btn--underline');
        }
        
        // 设置type属性
        if (!this.hasAttribute('type')) {
          this.setAttribute('type', 'button');
        }
      }

      addEventListeners() {
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(event) {
        event.preventDefault();
        
        if (!this.copyText) {
          console.warn('Copy button: No text to copy (data-copy-text attribute is required)');
          return;
        }
        
        // 复制文本到剪贴板
        this.copyToClipboard();
        
        // 显示成功消息
        this.showSuccessMessage();
      }

      copyToClipboard() {
        try {
          // 使用现代的Clipboard API
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(this.copyText).catch(err => {
              // 降级到传统方法
              this.fallbackCopyTextToClipboard();
            });
          } else {
            // 传统方法
            this.fallbackCopyTextToClipboard();
          }
        } catch (err) {
          console.error('Copy failed:', err);
        }
      }

      fallbackCopyTextToClipboard() {
        const textArea = document.createElement('textarea');
        textArea.value = this.copyText;
        
        // 确保文本区域不可见
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Fallback copy failed:', err);
        }
        
        document.body.removeChild(textArea);
      }

      showSuccessMessage() {
        // 保存当前文本
        const currentText = this.textContent;
        
        // 显示成功文本
        this.textContent = this.successText;
        
        // 添加成功状态类
        this.classList.add('copy-button--success');
        
        // 一段时间后恢复原始文本
        setTimeout(() => {
          this.textContent = this.originalText;
          this.classList.remove('copy-button--success');
        }, this.duration);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }
    }
  );
}